import {LogaProxy} from "./LogaProxy";

export class Operation {


  public static fromJson(json: Object): Operation {
    const o: Operation = new Operation();

    o.id = json['id'];
    o.code = json['code'];
    o.name = json['name'].trim();
    o.start = json['start'];
    o.end = json['end'];
    o.agency = json['agency'];
    o.agencyManager = json['agencyManager'];
    o.customerBU = json['customerBU']
    o.kits = json['merchandisingKits'];
    o.operationProfils = json['operationProfils'];
    o.typeOfMission = json['typeOfMission'];
    o.globalQuota = json['globalQuota'];

    return o;
  }

  public id: number;
  public code: string;
  public name: string;
  public start: Date;
  public end: Date;

  public agency: Agency;
  public agencyManager: AgencyManager;
  public typeOfMission: TypeOfMission;
  public customerBU: CustomerBU;

  public operationProfils: OperationProfil[];
  public kits: Kit[];

  public globalQuota: number;


  /**
   * keep only the active Operation Profiles
   */
  listActiveProfiles(): OperationProfil[] {
    let a: OperationProfil[] = [];
    for (let op of this.operationProfils)
      if (!op.inactive)
        a.push(op);
    return a;
  }

  findActiveKits() {
    if (this.kits != null)
      return this.kits.filter(a => !a.inactive)
    return [];
  }
}

export class Kit {
  public id: number;
  public code: string;
  public name: string;
  public inactive: boolean;
}

export class OperationProfil {
  public id: number;
  public code: string;
  public name: string;
  public inactive: true;
}

export class TypeOfMission {
  public id: number;
  public code: string;
  public name: string;
}

export class Agency {
  public id: number;
  public code: string;
  public name: string;
}

export class AgencyManager {
  public id: number;
  public code: string;
  public name: string;
}

export class CustomerBU {

  public static fromJson(json: Object): CustomerBU {
    const o: CustomerBU = new CustomerBU();

    o.id = json['id'];
    o.code = json['code'];
    o.name = json['name'];

    return o;
  }

  public id: number;
  public code: string;
  public name: string;
}

export class MissionPlanningPurposes {
    
  id: number;
  code: string;
  name: string;
  recommendedDurationInMinutes: number|null;
  rank: number;
  disabled: boolean;
    
  static FromJson(o: any): MissionPlanningPurposes{
    let m = new MissionPlanningPurposes();
    m.id = o.id;
    m.code = o.code;
    m.name = o.name;
    m.recommendedDurationInMinutes = o.recommendedDurationInMinutes;
    m.rank = o.rank;
    m.disabled = o.disabled;
    return m;
  }
}

export class OperationCustomerPlanningSetting {

  /**description of the operation to be displayed to the customer, to help him understand the goal of the operation, from his perspective")**/
  public operationCustomerDescription: string;

  /**
   * To use or not day off
   */
  public avoidDayOffInPlanning: boolean;

  /**
   * To show or hide customer feedback
   */
  public hideCustomerFeedback: boolean;

  /**
   * Number of consecutive days in customer planning , 2 days exactly for eg
   * (Monday following Tuesday and not Monday Wednesday...)
   */
  public nbOfConsecutivePlannedDays: number;

  /**
   * Delai de planification minimal
   */
  public maxDaysAheadPlanning: number;

  /**
   * The duration for one mission , exactly this value
   */
  public mandatoryMissionDurationInHours: number;

  /**
   * Delai de planification minimal (avec approbation client)
   */
  public needCustomerApprovalPlannedBefore: number;


  //default AM start time for Mission to plan
  public amStartTime: number;

  /**default AM end time for Mission to plan**/
  public amEndTime: number;

  /**default PM start time for Mission to plan**/
  public pmStartTime: number;

  /**default PM end time for Mission to plan**/
  public pmEndTime: number;

  /**starting this date, the customer can start to plan for this operation**/
  public planningOpenFrom: number;
  /**starting this date, the customer can no longer plan for this operation**/
  public planningOpenUntil: number;

  /**earliest date the user can use to plan**/
  public earliestPlannableDate: number;

  /**latest date the user can use to plan**/
  public latestPlannableDate: number;

  /**display Presence Check basic information on LOCUPA / planning application **/
  public showPresenceCheckInfos: boolean;

  /**CheckIn Questionnaire (controle de presence) visibility policy to be observed by LOCUPA / planning application")**/
  public showCheckInQuestionnaire: string;

  /**Cra visibility policy to be observed by LOCUPA / planning application**/
  public showCra: string;

  /**
   * Le client a accès aux informations de facturation
   */
  public showInvoicingInfos: boolean;

  /**
   *If true the customer would be allowed to select a Kit at planning, if false, the kit will not be shown at all (view/create)
   */
  public choseKitOnCustomerMissionPlaning: boolean;

  /**
   *
   */
  public useSlotPlanning: boolean;

  public shareAssignedWorkerInfoByEmail: boolean;

  /**
   * if true the user must be allowed to select several purpose when planning a new mission
   */
  public useMultiPurposePlanning: boolean;
  public missionPlanningPurposes: MissionPlanningPurposes[] = [];

  public hasTimeFix(): boolean {
    return this.amStartTime != null && this.amEndTime != null && this.pmStartTime != null && this.pmEndTime != null;
  }

  setup(src: OperationCustomerPlanningSetting) {
    this.operationCustomerDescription = src.operationCustomerDescription;
    this.avoidDayOffInPlanning = src.avoidDayOffInPlanning;
    this.hideCustomerFeedback = src.hideCustomerFeedback;
    this.nbOfConsecutivePlannedDays = src.nbOfConsecutivePlannedDays;
    this.maxDaysAheadPlanning = src.maxDaysAheadPlanning;
    this.mandatoryMissionDurationInHours = src.mandatoryMissionDurationInHours;
    this.needCustomerApprovalPlannedBefore = src.needCustomerApprovalPlannedBefore;
    this.amStartTime = src.amStartTime;
    this.amEndTime = src.amEndTime;
    this.pmStartTime = src.pmStartTime;
    this.pmEndTime = src.pmEndTime;
    this.planningOpenFrom = src.planningOpenFrom;
    this.planningOpenUntil = src.planningOpenUntil;
    this.earliestPlannableDate = src.earliestPlannableDate;
    this.latestPlannableDate = src.latestPlannableDate;
    this.showPresenceCheckInfos = src.showPresenceCheckInfos;
    this.showCheckInQuestionnaire = src.showCheckInQuestionnaire;
    this.showCra = src.showCra;
    this.showInvoicingInfos = src.showInvoicingInfos;
    this.choseKitOnCustomerMissionPlaning = src.choseKitOnCustomerMissionPlaning;
    this.useSlotPlanning = src.useSlotPlanning;
    this.shareAssignedWorkerInfoByEmail = src.shareAssignedWorkerInfoByEmail;
    this.useMultiPurposePlanning = src.useMultiPurposePlanning;

    if (src.missionPlanningPurposes != null)
      src.missionPlanningPurposes.forEach(p => {
        if(!p.disabled){
          this.missionPlanningPurposes.push(MissionPlanningPurposes.FromJson(p));
        }
      })
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/model/Operation.ts